export default {
  payment_methods_title: 'Payment details',
  monthly_payment_method_title: 'Monthly payment method:',
  monthly_payment_method_not_specified_title:
    'Monthly payment method was successfully deposited.',
  non_deposited: 'No payment method saved',
  payment_methods_intro:
    'Here you can save the payment method for your monthly invoice. ',
}
